export default __webpack_public_path__ + "0935dd14cec83ea99fe463040eeeb5a7.svg";